
import {Component, Prop} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import {ParaBirimi} from "@/enum/ParaBirimi";
import Tutar from "@/components/inputs/Tutar.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import ProtestoIhtarForm from "@/components/forms/ProtestoIhtarForm.vue";
import {AbstractFormWizard} from "@/abstract_classes/AbstractFormWizard";
import KararNumarasi from "@/components/inputs/KararNumarasi.vue";
import StepperValidationForm from "@/components/StepperValidationForm.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import AsilAlacakKalemiForm from "@/components/forms/alacak-kalemi/AsilAlacakKalemiForm.vue";
import IlamBilgileriForm from "@/components/forms/alacak/IlamBilgileriForm.vue";
import DovizTakipSekliPicker from "@/components/pickers/DovizTakipSekliPicker.vue";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import PopUp from "@/components/dialogs/PopUp.vue";
import {PopUpTitle} from "@/enum/PopUpTitle";
import {TakipTarihliKurEntity} from "@/entity/TakipTarihliKurEntity";

@Component({
  components: {
    PopUp,
    DovizTakipSekliPicker,
    IlamBilgileriForm,
    AsilAlacakKalemiForm,
    StepperValidationForm, KararNumarasi, ProtestoIhtarForm, ParaBirimiPicker, Tutar, Dates
  },
})
export default class TuketiciHakemHeyetiKarariAlacakFormWizard extends AbstractFormWizard {
  @Prop() takipTipi!: number;
  @Prop() takipTipiId!: number;
  @Prop() takipTalebi!: TakipTalebiEntity;
  @Prop() takipTarihliKurlar!: Array<TakipTarihliKurEntity>;

  PopUpTitle = PopUpTitle;
  paraBirimi = ParaBirimi;
  dovizTakipSekli = DovizTakipSekli;
  activeStep = 1;
  dialog = false;
  stepperHeaders = [
    "Tüketici hakem Heyeti Kararı",
    "Alacak Kalemi"
  ];
  defaultMahkeme = {
    ilam: 1,
    yargiBirimi: 13,
    dosya: 1
  }

  vadeCheck(){
    this.dialog=true;
  }
  stepCheck(){
    this.dialog=false;
    this.nextStep();
  }

  onParaBirimiChange() {
    if (this.localValue.para_birimi_id == this.paraBirimi.TRY)
      delete this.localValue.doviz_kur_tarihi;
    this.input();
  }

  mounted() {
    this.$emit('hide-button', true);
    if (!this.localValue.asil_alacaklar) {
      this.localValue.asil_alacaklar = [];
    }
  }

  nextStepRules() {
    return true;
  }

  previousStepRules() {
    return true;
  }
}

